module.exports = __webpack_public_path__ + "components/MapControl/svg/Kino.svg?8cf434df";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Kino.svg
// module id = 2047
// module chunks = 0